import { makeRequest } from 'utils/requestLogger';

export default () =>
  makeRequest('put', `api/users/disable-audio-connection-prompt/me`);



// WEBPACK FOOTER //
// ./src/app/services/account/disableAudioConnectionPrompt.js